// mumbai-locations.ts
// This file contains a static list of Mumbai locations for autocomplete use.

export const MUMBAI_LOCATIONS: string[] = [
  // Major Hubs
  "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
  "Mumbai Central",
  "Andheri",
  "Bandra",
  "Bandra Kurla Complex (BKC)",
  "Dadar",
  "Kurla",
  "Thane",
  "Navi Mumbai",
  "Vashi",
  "Panvel",
  "Belapur CBD",
  "Nerul",
  "Seawoods",
  "Kharghar",

  // South Mumbai
  "Colaba",
  "Fort",
  "Marine Drive",
  "Churchgate",
  "Nariman Point",
  "Cuffe Parade",
  "Ballard Estate",
  "Charni Road",
  "Girgaon",
  "Malabar Hill",
  "Walkeshwar",
  "Tardeo",
  "Byculla",
  "Mazgaon",
  "Worli",
  "Lower Parel",
  "Upper Worli",
  "Prabhadevi",
  "Parel",
  "Elphinstone Road",

  // Central Mumbai & Harbour
  "Sion",
  "Wadala",
  "Matunga",
  "Dadar East",
  "Dadar West",
  "Mahim",
  "Vadala",
  "Antop Hill",
  "Sewri",
  "Cotton Green",
  "Reay Road",
  "Dockyard Road",
  "Chembur",
  "Govandi",
  "Mankhurd",
  "Vikhroli",
  "Ghatkopar",
  "Mulund",
  "Bhandup",
  "Kanjurmarg",
  "Powai",

  // Western Suburbs
  "Bandra East",
  "Bandra West",
  "Khar",
  "Santacruz",
  "Juhu",
  "Ville Parle",
  "Andheri East",
  "Andheri West",
  "Jogeshwari",
  "Goregaon",
  "Malad",
  "Kandivali",
  "Borivali",
  "Dahisar",

  // Micro Localities (Western)
  "Lokhandwala Andheri",
  "Oshiwara",
  "Yari Road",
  "Seven Bungalows",
  "Four Bungalows",
  "Versova",
  "Mira Road",
  "Bhayandar",
  "Naigaon",
  "Vasai",
  "Nalasopara",
  "Virar",

  // Navi Mumbai Suburbs
  "Kamothe",
  "Kalamboli",
  "Taloja",
  "Ulwe",
  "Dronagiri",
  "Airoli",
  "Ghansoli",
  "Kopar Khairane",
  "Turbhe",
  "Sanpada",
  "Juinagar",

  // Thane Belt
  "Mulund East",
  "Mulund West",
  "Thane West",
  "Thane East",
  "Majiwada",
  "Ghodbunder Road",
  "Kalwa",
  "Mumbra",
  "Kalyan",
  "Dombivli",
  "Ambarnath",
  "Badlapur",
  "Shilphata",

  // Andheri–Powai Belt
  "Hiranandani Gardens",
  "Chandivali",
  "Marol",
  "Sakinaka",

  // Ghatkopar–Vikhroli Belt
  "Pant Nagar",
  "Asalpha",
  "Kannamwar Nagar",
  "Tagore Nagar",

  // Ghatkopar–Chembur Link Areas
  "Suman Nagar",
  "RCF Colony",

  // Kurla–Sion Belt
  "Nehru Nagar",
  "Kurla West",
  "Kurla East",

  // Slum Clusters
  "Dharavi",
  "Behram Baug",
  "Patel Nagar Jogeshwari",

  // Landmarks
  "Chhatrapati Shivaji International Airport T2",
  "Domestic Airport Terminal 1",
  "Phoenix Mall Lower Parel",
  "Palladium Mall",
  "R City Mall Ghatkopar",
  "Inorbit Mall Malad",
  "Oberoi Mall Goregaon",
  "Infinity Mall Andheri",
  "Haji Ali",
  "Siddhivinayak Temple",
  "Bandra-Worli Sea Link",
  "Gateway of India",
  "Juhu Beach",
  "Chowpatty Beach",
  "Sanjay Gandhi National Park",
];
